import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import * as blogActions from '../../actions/blogActions';
import Loading from '../common/Loading';
import articleTypes from '../../constants/articleTypes';
import DiscoverSummaryItem from './DiscoverSummaryItem';
import * as browserCheck from '../../utils/browserCheck.js';
import Advert from '../common/Advert';
import ErrorMessage from '../common/ErrorMessage';


class DiscoverPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getTitle = this.getTitle.bind(this);
        this.getMetaDescription = this.getMetaDescription.bind(this);
        this.getHeader = this.getHeader.bind(this);
        this.getIntro = this.getIntro.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.getPosts = this.getPosts.bind(this);
        this.initialiseMasonry = this.initialiseMasonry.bind(this);
    }

    componentWillMount() {   
        this.getPosts();
    }

    componentDidMount() {  
        if(this.props.blog.items.length) {
            this.initialiseMasonry();
        }
    }

    componentDidUpdate(prevProps, prevState) {     
        //we might also need something here for if we've added more items?
        if(!prevProps.blog.items.length && this.props.blog.items.length) {
            this.initialiseMasonry();
        }
    }

    initialiseMasonry() {
        if ($('#newsstream').length != 0 && browserCheck.canUseDom()) {
            const Masonry = require('masonry-layout');
            const imagesLoaded = require('imagesloaded');
            let msnry;
            let container = document.querySelector('#newsstream');
            imagesLoaded(container, function () {
                msnry = new Masonry(container, {
                    columnWidth: '.grid-sizer',
                    itemSelector: '.mdl-card',
                    isFitWidth: true,
                    gutter: 0
                });
            });
        }
    }

    loadNextPage() {
        this.getPosts(this.props.blog.lastPage + 1);
    }

    getPosts(page = 1) {
        this.props.actions.getPosts(articleTypes.discover, page);
    }


    getTitle() {
        return 'Discover New Music - Reviews and Interviews with Independent Artists - LoudUp';
    }

    getMetaDescription() {
        return 'Discover new bands and artists, find out all about the music and the people behind it!';
    }

    getHeader() {
        return 'Discover new music';
    }

    getIntro() {
        return 'Discover new bands and artists, find out all about the music and the people behind it';
    }

    render() {
        return (
            <div className="main blog">     
                <MetaTags>
                    <title>{this.getTitle()}</title>            
                    <meta id="description" name="description" content={this.getMetaDescription()} />                
                </MetaTags>
                <div className="container">
                    <div className="block-inner minimal-height" style={{paddingLeft: '0', paddingRight: '0'}}>   
                        <div className="blog-content">
                             <React.Fragment>
                                <h1 className="section-alt">{this.getHeader()}</h1>
                                <p className="sectintro">{this.getIntro()}</p>
                            </React.Fragment>
                            <div className="row">
                                <div className="col-md-12">
                                    <div id="blogSummaryContainer">
                                    {
                                        this.props.blog.items.length ?
                                            <div className="newsgrid effect-2" id="newsstream">
                                                {
                                                    this.props.blog.items.map((item, index) => {
                                                        return <React.Fragment key={index}>
                                                            <DiscoverSummaryItem key={item.Link} item={item} index={index} />   
                                                            {
                                                                index === 2 ?
                                                                    <div key={`${item.Link}-promo`} className="demo-card-wide mdl-card mdl-shadow--2dp ad">
                                                                        <div className="content-side-2">
                                                                            <Advert adType="Square" onLoaded={this.initialiseMasonry} textPadding="5px" />
                                                                        </div>
                                                                    </div>
                                                                    : null
                                                            }
                                                        </React.Fragment>;
                                                    })
                                                }
                                            </div>
                                        :
                                            this.props.blog.loadingStatus && this.props.blog.loadingStatus.status == 'LOADING' ? 
                                                <span style={{paddingLeft: '20px'}}><Loading /></span> 
                                                : 
                                                this.props.blog.loadingStatus && this.props.blog.loadingStatus.status == 'FAILED' ?
                                                    <div style={{padding: '20px'}}>
                                                        <ErrorMessage error="Sorry, something went wrong! Unable to load content." />
                                                    </div>
                                                    :
                                                    <p style={{paddingLeft: '20px'}}>No items found</p>
                                    }
                                    {this.props.blog.haveNextPage ?
                                        this.props.blog.loadingStatus.status == 'LOADING' && this.props.blog.loadingStatus.page > 1 ?
                                        <span style={{paddingLeft: '20px'}}><Loading /></span> :
                                            <div id="divLoadNext" style={{textAlign:'center'}}>
                                                <button id="btnLoadNext" className="btn btn-outline transition" style={{marginTop:'15px'}} onClick={this.loadNextPage}>Show More...</button>
                                            </div>
                                        : null
                                    }
                                    </div>
                                </div>                                 
                            </div>  
                        </div>                   
                    </div>
                </div>
            </div>
        );
    }
}

DiscoverPage.propTypes = {
    blog: PropTypes.object,
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { blog: state.blog['discover'] };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, blogActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscoverPage);
